// extracted by mini-css-extract-plugin
export var how_to = "HowTo-module--how_to--68a18";
export var how_to_tab = "HowTo-module--how_to_tab--5d3fc";